import moment from 'moment';

export default function getDate(startDate, endDate) {

    if (startDate != null && endDate != null) {
        let firstDate = moment(startDate).format('yyyy-MM-DD');
        let secondDate = moment(endDate).format('yyyy-MM-DD');
        let firstMonth = moment(startDate).format('MMMM');
        let secondMonth = moment(endDate).format('MMMM');
        let firstDay = moment(startDate).format('D');
        let secondDay = moment(endDate).format('D');
        let firstYear = moment(startDate).format('YYYY');
        let secondYear = moment(endDate).format('YYYY');

        if (firstDate == secondDate) {
            return moment(startDate).format('MMMM D');
        }
        else if (firstMonth == secondMonth && firstDay != secondDay && firstYear == secondYear) {
            let retValue = firstMonth + ' ' + firstDay + ' - ' + secondDay;
            return retValue;
        }
        else if (firstMonth != secondMonth && firstYear == secondYear) {
            let retValue = firstMonth + ' ' + firstDay + ' - ' + secondMonth + ' ' + secondDay;
            return retValue;
        }
        else if (firstYear != secondYear) {
            let retValue = firstMonth + ' ' + firstDay + ', ' + firstYear + ' - ' + secondMonth + ' ' + secondDay + ', ' + secondYear;
            return retValue;
        }
    }
    return '';
}